import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'kt-order-statistic-cart',
    templateUrl: './order-statistic-cart.component.html',
    styleUrls: ['./order-statistic-cart.component.scss']
})
export class OrderStatisticCartComponent implements OnInit {

    @Input() name: string = null;
    @Input() color: string = null;
    @Input() totalCount: number = null;
    @Input() total: number = null;

    constructor() {
    }

    ngOnInit(): void {
    }

}
